<template>
  <div>
    <div class="row">
      <div class="col-md-6 col-sm-12 col">
        <InputTagDropdownDestination :inputData.sync="selectedDestination" @onChange="destinationChanged" />
      </div>
      <div class="col-md-6 col-sm-12 col text-right">
        <input id="imageUploadBtn" type="file" multiple="multiple" accept="image/*" hidden @change="selectFile" />
        <button v-if="photoIds.length != 0" class="btn btn-danger mr-2" @click="deleteFiles()">Delete images</button>
        <button
          v-if="selectedDestination.length != 0"
          class="btn btn-primary"
          @click="chooseFiles()"
          :disabled="isUploading"
        >
          Upload images
        </button>
      </div>
    </div>

    <div class="mt-3">
      <transition>
        <div v-if="loading" class="text-center my-3">Loading ...</div>
      </transition>
      <table id="table-operator" class="table table-sm table-nowrap card-table">
        <thead class="text-primary">
          <tr>
            <th>
              <!-- <input type="checkbox" @click="selectAll" v-model="allSelected" /> -->
            </th>
            <th>
              <span v-if="photoIds.length != 0">{{ photoIds.length }} selected </span>
            </th>
            <th>File name</th>
            <th>Size</th>
            <th>Link</th>
          </tr>
        </thead>
        <tbody v-if="tourPhotos.length != 0">
          <tr
            v-for="photo in tourPhotos.slice((pageNumber - 1) * rowPerPage, pageNumber * rowPerPage)"
            :key="photo._id"
            @click="edit(photo)"
          >
            <td><input type="checkbox" v-model="photoIds" :value="photo.filepath" @click.stop="stopTheEvent" /></td>
            <td>
              <img
                v-lazy="{
                  src: photo.filepath,
                  error: require('@/assets/images/no-thumbnail-banner.jpg'),
                  loading: require('@/assets/images/no-thumbnail-banner.jpg'),
                }"
                height="50"
              />
            </td>
            <td>{{ photo.filename }}</td>
            <td>{{ Math.round(photo.fielsize / 100) / 10 }}kb</td>
            <td>
              <button class="btn btn-success" :title="photo.filepath" @click.stop="copyToClipBoard(photo.filepath)">
                <i class="icofont-link text-white"></i> Copy link
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="mt-3 text-center" v-if="tourPhotos.length == 0">No images for this destination</div>
    </div>

    <PhotoPreviewModal :img="img" :width="width" :height="height"></PhotoPreviewModal>

    <paginate
      v-if="tourPhotos.length"
      v-model="pageNumber"
      :page-count="Math.ceil(tourPhotos.length / rowPerPage)"
      :prev-text="'Prev'"
      :next-text="'Next'"
      :container-class="'pagination mt-4'"
      :page-class="'page-item'"
      :prev-class="'page-link'"
      :next-class="'page-link'"
      :page-link-class="'page-link'"
    />

    <div v-if="isUploading" class="uploading-progress border bg-dark p-3 text-white">
      <div class="position-relative">
        <p v-if="uploadProcess" class="text-white text-center mb-3">Uploading is in progress...</p>
        <p v-else class="text-white text-center mb-3">Uploading process completed!</p>
        <button @click="closeProgress()" type="button" class="close position-absolute top-0 right-0" aria-label="Close">
          <span aria-hidden="true"><i class="icofont-close-circled text-white"></i></span>
        </button>
        <div
          v-for="(image, key) in images"
          :key="key"
          class="mb-2 py-2 row px-3 align-items-center justify-content-start"
        >
          <div class="img-wrapper">
            <img width="50" height="50" v-bind:ref="'image' + parseInt(key)" />
          </div>
          <div>
            &nbsp;&nbsp;&nbsp;
            <span v-if="uploadStatus[key] == 0"> Uploading ...</span>
            <span v-else-if="uploadStatus[key] == 1" class="text-success">Upload Success !</span>
            <span v-else-if="uploadStatus[key] == 2" class="text-danger">Failed to upload. Conflict error.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import $ from "jquery";
import Paginate from "vuejs-paginate";
import InputTagDropdownDestination from "./InputTagDropdownDestination.vue";
import PhotoPreviewModal from "./PhotoPreviewModal.vue";

export default {
  components: {
    Paginate,
    InputTagDropdownDestination,
    PhotoPreviewModal,
  },

  data() {
    return {
      selectedDestination: "",
      selected: [],
      allSelected: false,
      photoIds: [],

      loading: false,
      imageLen: 0,
      isAdding: false,

      alt: "",
      img: "",
      width: 0,
      height: 0,

      pageNumber: 1,
      rowPerPage: 10,

      // image upload part
      selectedFiles: undefined,
      images: [], // preview part
      progressInfos: [],
      message: "",
      fileInfos: [],
      isUploading: false,
      uploadStatus: [],
      uploadProcess: true,
    };
  },

  computed: {
    ...mapGetters(["tourDestinations", "tourPhotos"]),
  },

  methods: {
    ...mapActions([
      "fetchTourPhotos",
      "fetchTourDestinations",
      "hideBarLoading",
      "uploadTourPhotoGallery",
      "deleteTourPhoto",
    ]),

    fetchPhoto(selectedDestination) {
      const dest = selectedDestination.toUpperCase().replace(/\s+/g, "_");
      this.filterPhoto(dest);
    },

    async filterPhoto(destination) {
      this.loading = true;
      await this.fetchTourPhotos(destination).then(() => {
        this.loading = false;
        this.imageLen = this.tourPhotos.length;
        this.pageNumber = 1;
      });
    },

    copyToClipBoard(textToCopy) {
      navigator.clipboard.writeText(textToCopy);
      this.$notify({ group: "alert", text: "Link Copied" });
    },

    chooseFiles() {
      document.getElementById("imageUploadBtn").click();
    },

    deleteFiles() {
      const dP = this;
      $.confirm({
        title: "",
        content: "Are you sure want to delete these images?",
        buttons: {
          confirm: async () => {
            for (let i = 0; i < dP.photoIds.length; i++) {
              await dP
                .deleteTourPhoto({ url: dP.photoIds[i] })
                .then((response) => {
                  if (response.data.code == "ERR_INVALID_URL") {
                    this.$notify({ group: "alert", text: "Invalid URL Error" });
                  }
                })
                .catch((e) => {
                  console.log(e);
                });
            }
          },
          cancel: () => {},
        },
      });
    },

    destinationChanged() {
      this.fetchPhoto(this.selectedDestination);
      this.photoIds = [];
    },

    selectAll() {
      this.photoIds = [];

      if (!this.allSelected) {
        for (let photo in this.tourPhotos) {
          this.photoIds.push(photo);
        }
      }
    },

    edit(data) {
      this.img = data.filepath;
      this.showEditModal();
    },

    showEditModal() {
      $("#image-alt").modal("show");
      setTimeout(() => {
        this.width = document.getElementById("preview-modal-image").naturalWidth;
        this.height = document.getElementById("preview-modal-image").naturalHeight;
      }, 200);
    },
    closeModal() {
      $("#image-alt").modal("hide");
      this.width = "";
      this.height = "";
    },

    stopTheEvent: (event) => event.stopPropagation(),

    selectFile(e) {
      this.selectedFiles = e.target.files;
      if (this.selectedFiles.length == 0) return;
      this.isUploading = true;
      this.progressInfos = [];
      
      // Generate filename and rename files
      var currentdate = new Date();
      var datetime =
        "_" +
        currentdate.getFullYear() +
        "_" +
        (currentdate.getMonth() + 1) +
        "_" +
        currentdate.getDate() +
        "_" +
        currentdate.getHours() +
        "_" +
        currentdate.getMinutes() +
        "_" +
        currentdate.getSeconds();
      let filenameBase = this.selectedDestination.toUpperCase().replace(/ /g, "_");
      let filename = filenameBase + datetime;
      
      // Rename files before preview/upload
      // (Commented out so original filenames are preserved. Kept for possible future use.)
      for (let i = 0; i < this.selectedFiles.length; i++) {
        const file = this.selectedFiles[i];
        /*
        const ext = file.name.split(".").pop(); // get extension
        const newName = filename + "." + ext;

        // Create a new File with the renamed name
        const renamedFile = new File([file], newName, { type: file.type });
        this.images.push(renamedFile);
        */
        // Use original file name
        this.images.push(file);
      }

      for (let i = 0; i < this.images.length; i++) {
        let reader = new FileReader(); //instantiate a new file reader
        reader.addEventListener(
          "load",
          function () {
            this.$refs["image" + parseInt(i)][0].src = reader.result;
          }.bind(this),
          false
        ); //add event listener

        reader.readAsDataURL(this.images[i]);
      }

      //upload start
      this.message = "";

      this.uploadStatus = [];

      for (let i = 0; i < this.images.length; i++) {
        //upload function
        this.uploadStatus.push(0);
        this.upload(i, this.images[i]);
      }
    },

    upload(idx, file) {
      // file is already renamed in selectFile, use its name
      const filenameWithoutExt = file.name.replace(/\.[^/.]+$/, ''); // remove extension
      this.progressInfos[idx] = { percentage: 0, fileName: file.name };

      let formData = new FormData();
      formData.append("photo", file);
      formData.append("filename", filenameWithoutExt);

      this.uploadTourPhotoGallery(formData)
        .then((response) => {
          let prevMessage = this.message ? this.message + "\n" : "";
          this.message = prevMessage + response.data.message;
          this.uploadStatus[idx] = 1; // success
          this.$set(this.uploadStatus, idx, 1);
          this.checkUploadingStatus();
        })
        .catch((e) => {
          this.progressInfos[idx].percentage = 0;
          this.message = "Could not upload the file:" + file.name;
          this.uploadStatus[idx] = 2; // error
          this.$set(this.uploadStatus, idx, 2);
          this.checkUploadingStatus();
        });
    },

    checkUploadingStatus() {
      for (let i = 0; i < this.uploadStatus.length; i++) {
        if (this.uploadStatus[i] == 0) {
          return;
        }
      }
      this.uploadProcess = false;
    },

    closeProgress() {
      this.isUploading = false;
      this.images = [];
    },
  },
};
</script>

<style scoped>
table tr:hover {
  background-color: #f1f2f3;
  cursor: pointer;
}
.pagination {
  justify-content: center;
}
a:hover {
  text-decoration: underline;
}

/* uploading progress */
.uploading-progress {
  border-radius: 10px;
  position: fixed;
  bottom: 20px;
  right: 20px;
  min-width: 300px;
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 90vh;
}
.uploading-progress img {
  object-fit: cover;
  border-radius: 50%;
}
</style>